@let availability = availabilitySg();

@if (availability) {
  <div class="atn-summit-org-chart-node-panel-availability-tab">
    <div class="atn-summit-org-chart-node-panel-availability-tab__item">
      <div class="atn-summit-org-chart-node-panel-availability-tab__item-name">
        Current Weekly Availability (hrs)
      </div>
      <div class="atn-summit-org-chart-node-panel-availability-tab__item-value">
        {{ availability.currentMonthHours }}
      </div>
    </div>
  </div>
}
